export default __webpack_public_path__ + "static/process-08-7260e4152a4ccbd6b5813a90e88b2ef5.svg";